import {
  UPDATE_STARTDATE,
  UPDATE_ENDDATE,
  UPDATE_TIMEFRAME,
  CHANGE_TIMEFRAMETYPE,
  UPDATE_TIMEFRAME_WITH_DATERANGE,
  UPDATE_TIMEFRAME_BUTTONS
} from '../actions/timeframe'
import moment from 'moment'
import 'moment/locale/pt-br'

let startDate, endDate, timeframeStartDate, timeframeEndDate

startDate = moment().subtract(8, 'days')
timeframeStartDate = moment().subtract(8, 'days').format('YYYY-MM-DD') + 'T00:00:00.000-03:00'
endDate = moment().subtract(1, 'days')
timeframeEndDate = moment().subtract(1, 'days').format('YYYY-MM-DD') + 'T23:59:59.000-03:00'

const initialState = {
  startDate: startDate,
  endDate: endDate,
  timeframe: {
    start: timeframeStartDate,
    end: timeframeEndDate
  },
  timeframeType: 'calendar',
  timeframeButtons: {
    today: false,
    sevenDays: true,
    fifteendays: false,
    thirtyDays: false
  }
}

const timeframeReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_STARTDATE:
      return {
        ...state,
        startDate: action.payload
      }
    case UPDATE_ENDDATE:
      return {
        ...state,
        endDate: action.payload
      }
    case UPDATE_TIMEFRAME:
      return {
        ...state,
        timeframe: {
          start: `${moment(state.startDate).format('YYYY-MM-DD')}T00:00:00.000-03:00`,
          end: `${moment(state.endDate).format('YYYY-MM-DD')}T23:59:59.000-03:00`
        }
      }
    case UPDATE_TIMEFRAME_WITH_DATERANGE:
      return {
        ...state,
        startDate: action.payload.startDate,
        endDate: action.payload.endDate,
        timeframe: {
          start: `${moment(action.payload.startDate).format('YYYY-MM-DD')}T00:00:00.000-03:00`,
          end: `${moment(action.payload.endDate).format('YYYY-MM-DD')}T23:59:59.000-03:00`
        }
      }
    case CHANGE_TIMEFRAMETYPE:
      return {
        ...state,
        timeframeType: action.payload
      }
    case UPDATE_TIMEFRAME_BUTTONS:
      return {
        ...state,
        timeframeButtons: action.payload
      }
    default:
      return state
  }
}

export default timeframeReducer



// WEBPACK FOOTER //
// ./src/reducers/timeframeReducer.js